import { render, staticRenderFns } from "./ExpandedItem.vue?vue&type=template&id=74996820&"
import script from "./ExpandedItem.vue?vue&type=script&lang=ts&"
export * from "./ExpandedItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports